export enum UsageType {
  CUSTOM = 'CUSTOM',
  SYSTEM = 'SYSTEM',
}
